import { render, staticRenderFns } from "./CheckboxInputGroup.vue?vue&type=template&id=54c8f9a8&scoped=true&"
import script from "./CheckboxInputGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8f9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c8f9a8')) {
      api.createRecord('54c8f9a8', component.options)
    } else {
      api.reload('54c8f9a8', component.options)
    }
    module.hot.accept("./CheckboxInputGroup.vue?vue&type=template&id=54c8f9a8&scoped=true&", function () {
      api.rerender('54c8f9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/formcomponents/CheckboxInputGroup.vue"
export default component.exports